export const normalizeToArray = (value?: string | string[]) => {
  if (Array.isArray(value)) return value;
  return value ? [value] : [""];
};

export const arraysEqual = (a: string[], b: string[]) => {
  return (
    JSON.stringify([...a].sort((x, y) => x.localeCompare(y))) ===
    JSON.stringify([...b].sort((x, y) => x.localeCompare(y)))
  );
};
